import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { CoverageRuleAction } from './coverageRule.action';
import { coverageRuleInitialState } from './coverageRule.constant';
import { ICoverageRuleStore } from './coverageRule.interface';

export const coverageRuleReducer = reducerWithInitialState(coverageRuleInitialState)
  .case(CoverageRuleAction.loadList.started, (state, { ruleSetId }): ICoverageRuleStore => ({
    ...state,
    ruleSetId,
    networkStatus: NetworkStatus.Started,
  }))
  .case(CoverageRuleAction.loadList.done, (state, { result }): ICoverageRuleStore => ({
    ...state,
    ruleSetId: result.ruleSetId,
    list: result.rules,
    networkStatus: NetworkStatus.Done,
  }))
  .case(CoverageRuleAction.loadList.failed, (state): ICoverageRuleStore => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(CoverageRuleAction.destroy, () => ({ ...coverageRuleInitialState }));
